import { render } from "./IntroduzioneView.vue?vue&type=template&id=a0b77262&scoped=true"
import script from "./IntroduzioneView.vue?vue&type=script&lang=js"
export * from "./IntroduzioneView.vue?vue&type=script&lang=js"

import "./IntroduzioneView.vue?vue&type=style&index=0&id=a0b77262&scoped=true&lang=css"

import exportComponent from "/Users/marco/Documents/visivalab/vueprojects/rembrandt-touch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b77262"]])

export default __exports__